import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../components/atoms/Button';
import CustomModal from '../../../../components/molecules/CustomModal';
import PermissionChecker from '../../../../components/molecules/PermissionChecker';
import { appActions, workOrderFormActions } from '../../../../store/slices';
import { WorkOrderService } from '../../../../service';
import { useNavigate } from 'react-router';

export default function FormConfirm() {

    const dispatch = useDispatch();
    const state = useSelector(state => state.auth);
    const isLoading = useSelector((state) => state.app.isLoading);
    const workOrderForm = useSelector(state => state.workOrderForm.workOrderForm);
    const [isOpen, setIsOpen] = useState(false);
    const navigate = useNavigate();

    const handleOpen = () => {
        setIsOpen(true);
    }

    const submitProductHandler = async () => {
        try {
            dispatch(appActions.setLoading(true));
            const data = await WorkOrderService.addWorkOrder(workOrderForm);
            const workOrderId = workOrderForm.workOrderId
            console.log(data);
            dispatch(workOrderFormActions.clearWorkOrderForm());
            dispatch(workOrderFormActions.setWorkOrderCounter(workOrderId));

            // set the current user as the confirming person
            dispatch(workOrderFormActions.confirm(state.user))
            setTimeout(() => {
                navigate('/factory/form-tracking')
            }, 100)
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }

    const MODAL_BUTTONS = [
        {
            name: 'İptal',
            variant: 'primary',
            onClick: () => setIsOpen(false)
        },
        {
            name: 'Onayla',
            variant: 'light',
            onClick: async ({ role }) => {
                submitProductHandler();
                setIsOpen(false)
            }
        }
    ]

    const ConfirmButtonGenerator = ({ role, requestedPermission }) => {
        const isDisabled = isLoading || workOrderForm.rows.length === 0;
        return (
            <PermissionChecker requestedPermission={requestedPermission}>
                <Button title={'Onayla'} async loading={isLoading} disabled={isDisabled} variant={'primary'} onClick={handleOpen} />
            </PermissionChecker>
        )
    }

    return (
        <div className='form-confirm-container'>
            {/* Confirm area for the technician */}
            <div className='form-confirm'>
                <div className='form-confirm-title'>
                    <p>Kalite Kontrol Sorumlusu</p>
                    <PermissionChecker requestedPermission={'confirmButtonQaTechnician'}>
                        <span>{`${state.user.name} ${state.user.surname}`}</span>
                    </PermissionChecker>
                </div>
                <ConfirmButtonGenerator role={'qaTechnician'} requestedPermission={'confirmButtonQaTechnician'} />
            </div>

            {/* Confirm area for the engineer */}
            <div className='form-confirm'>
                <div className='form-confirm-title'>
                    <p>Kontrol Eden</p>
                    <PermissionChecker requestedPermission={'confirmButtonQaEngineer'}>
                        <span>{`${state.user.name} ${state.user.surname}`}</span>
                    </PermissionChecker>
                </div>
                <ConfirmButtonGenerator role={'qaEngineer'} requestedPermission={'confirmButtonQaEngineer'} />
            </div>
            
            <CustomModal
                title={'Formu Onayla'}
                message={' Onaylama işlemi geri alınamaz! Formu onaylamak istediğinizden emin misiniz?'}
                buttons={
                    MODAL_BUTTONS
                }
                onOk={isOpen}
                onClose={() => setIsOpen(false)}
            />
        </div>
    );
}